import { useState, useEffect } from 'react';

const Regiones =
({
    checking,
    setChecking,
    codigosRegiones,
    setCodigosRegiones,
    checkboxesRegiones,
    setCheckboxesRegiones,
    regiones,
    sorting,
    loading,
    setPagination,
    status422
}) =>
{
    const [count, setCount] = useState(0);

    const appDebug = process.env.REACT_APP_DEBUG;

    const handleChildCheckbox = (e) =>
    {
        setChecking(true);

        const checked = e.target.checked;
        const region = e.target.value;

        if (checked === true)
        {
            const regiones = [];

            for (let i = 0; i < codigosRegiones.length; i++)
            {
                regiones.push(codigosRegiones[i]);
            }

            regiones.push(region);

            setCodigosRegiones(regiones);
        }
        else
        {
            const regiones = codigosRegiones.filter(nombre => nombre !== region);

            setCodigosRegiones(regiones);
        }

        // 1. Tu lógica para actualizar el estado en React
        setCheckboxesRegiones(
        {
            ...checkboxesRegiones,
            [region]: checked
        });

        // 2. Enviar la acción a Google Tag Manager
        if (window.dataLayer)
        {
            window.dataLayer.push(
            {
                event: 'buscador_experto_pesqueria_checkbox_region',
                buscador_experto_pesqueria_checkbox_region: document.querySelector(`label[for="${e.target.id}"]`).textContent,
                checkbox_accion: checked ? 'marcado' : 'desmarcado',
            });
        }

        setPagination(1);
    }

    useEffect(() =>
    {
        let contador = 0;

        regiones.map((region) => (contador += region.REGISTROS));

        setCount(contador);
    }, [regiones]);

    return (
        count > 0 &&
        (
            <div className="card border-0 mb-1">
                <div className="accordion" id="accordionPanelEspecie">
                    <div className="accordion-item">
                        <h5 className="accordion-header"><button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsRegiones" aria-expanded="true" aria-controls="panelsRegiones">Regiones:</button></h5>
                        <div id="panelsRegiones" className="accordion-collapse collapse">
                            <div className="accordion-body">

                                {
                                    regiones.map((region, index) =>
                                    (
                                        <div className="row" key={index}>
                                            <div className="col">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input border-dark-subtle"
                                                        id={`region-${index}`}
                                                        name="nombre_especie"
                                                        value={region.COD_REGION}
                                                        onChange={handleChildCheckbox}
                                                        checked={Object.hasOwn(checkboxesRegiones, `${region.COD_REGION}`) ? checkboxesRegiones[`${region.COD_REGION}`] : false}
                                                        disabled={!status422 && (!loading || checking || sorting)}
                                                    />
                                                    <label className="form-check-label" htmlFor={`region-${index}`}>{region.NOMBRE_REG}</label>
                                                </div>
                                            </div>

                                            {
                                                appDebug === 'true' &&
                                                (
                                                    <div className="col-3 text-end">{region.REGISTROS.toLocaleString('es-CL')}</div>
                                                )
                                            }

                                        </div>
                                    ))
                                }

                            </div>
                        </div>

                        {
                            appDebug === 'true' &&
                            (
                                <div className="text-end p-2">Elementos totales: {count.toLocaleString('es-CL')}</div>
                            )
                        }

                    </div>
                </div>
            </div>
        )
    );
}

export default Regiones;
